module.exports = new __parcel__URL__("ankleslice.1ae45896.png").toString();